import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_URL } from './dicom.service';
import { DLPipeline } from './dl-pipelines';

@Injectable({
  providedIn: 'root'
})
export class DeepLearningService {
1
  constructor(private http: HttpClient, @Inject(BASE_URL) private baseUrl: string) { }

  public getDefinedPipelines(): Observable<DLPipeline[]> {
    return this.http.get<DLPipeline[]>(this.baseUrl + '/cdss/deep-learning');
  }
}
